
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayStackedInleftRight50 as ObiThreewayStackedInleftRight50Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-stacked-inleft-right-50.js';
 
 
 

 
 export const ObiThreewayStackedInleftRight50 = createComponent({
   react: React,
   tagName: 'obi-threeway-stacked-inleft-right-50',
   elementClass: ObiThreewayStackedInleftRight50Element,
   events: {
     
   }
  });
 
 